/* eslint-disable */
<template>
  <q-page padding>
    <div>
      Validating...
    </div>
  </q-page>
</template>

<script>
/* eslint-disable */

import gql from "graphql-tag";

export default {
  name: "Humm",
  data() {
    return{
      params:this.$route.params,
      query:this.$route.query
    }
  },
  computed: {},
  async created(){
    return new Promise(async(resolve, reject) => {
        console.log('bfrcreated',this.$route.params.id );
          let preValidation = await this.preValidate_query()
          console.log(preValidation);
          
          if(preValidation.status == 'completed') this.$router.push(`/retail/place-order/${preValidation.order._id}`)
          else if(preValidation.status == 'failed') this.$router.push(`/humm_failed`)
          else this.$router.push(`/retail`)
      })

    
    
  },
  methods:{
    async checkPreValidation(){
    },
    async preValidate_query(){
      try {
        const result = await this.$apollo.query({
          query: gql`query preValidation ($id: ID!) {
          preValidation (id: $id) {
          id
          cartId
          token
          voucher
          valid
          status
          hummResponse
          shippingDetails
          account
          order
        }
      }`,
      variables: {
        id: this.$route.params.id
      },      
      fetchPolicy: 'network-only'
      })        
      return result.data.preValidation;
    } catch (error) {
      console.log("shippingPriceData Error:", error)
      throw new Error(error);    
    }      
  }
  }
};
</script>
